<template>
  <bPanel title="Create Account" tag="article" class="mt-3">
    <p>No implemented yet.</p>
  </bPanel>
</template>

<script>
import bPanel from "@/components/atoms/bPanel.vue";

export default {
  name: "CreateView",
  components: {
    bPanel,
  },
};
</script>
